import { useEffect, useState } from 'react'

interface Props {
  locale: string
  type: Intl.DisplayNamesOptions['type']
}

const useDisplayNames = ({ locale, type }: Props): [Intl.DisplayNames] => {
  const [displayNames, setDisplayNames] = useState<Intl.DisplayNames>()

  useEffect(() => {
    try {
      setDisplayNames(new Intl.DisplayNames([locale], { type }))
    } catch (e) {
      // browser does not support Intl.DisplayNames, fail silently
    }
  }, [locale, type])

  return [displayNames]
}

export default useDisplayNames
